<template>
    <div class="group">
        <input type="text" :placeholder="l10nSearchPlaceHolder" v-model="searchTerm" @input="onInput">
        <span class="icon"><font-awesome-icon :icon="['fal', 'search']"/></span>
        <!--<span class="highlight"></span>-->
        <span class="bar"></span>
    </div>
</template>

<script>
    import helpers from '../../services/helpers'
    import {SET_SEARCH_TERM, SEARCH} from '../../services/constants'

    export default {
        name: 'jabra-input',
        props: {
            disabled: {
                type: Boolean,
                default: false,
            },
            dark: {
                type: Boolean,
                default: false,
            },
            type: {
                type: String,
                default: 'button',
            },
        },
        computed: {
            searchStoreModule() {
                return this.$store.state.searchModule
            },
            searchTerm: {
                get() {
                    return this.searchStoreModule.searchTerm
                },
                set(newValue) {
                    this.$store.commit(SET_SEARCH_TERM, newValue)
                }
            },
            l10nSearchPlaceHolder() {
                return this.l10nGetter('search_placeholder_text')
            },

        },
        methods: {
            onInput(evt) {
                this.$store.dispatch(SEARCH)
            },
            l10nGetter(key) {
                return helpers.uiTextGetter(this.$store, key)
            },

        }
    }
</script>

<style scoped lang="scss">
    @import "../../scss/main";

    $width: 300px;
    .group {
        position: relative;
    }

    $transition-time: 0.2s;
    .icon {
        position: absolute;
        bottom: 2px;
        color: $font-color-blue;
        transition: color $transition-time;
    }

    input {
        font-size: 18px;
        display: block;
        width: $width;
        padding: 0 0 2px 22px;
        @include font-abraham(16px, $font-color-blue, 300);
        outline: none;
        background: $white-1;
        -webkit-appearance: none;
        border: none;
        border-bottom: white solid 1px;
    }

    input:focus {
        outline: none;
        border-bottom: white solid 0;
        transition: $transition-time ease all;
        + .icon {
            color: $accent-1;
        }

    }

    /* LABEL ======================================= */

    /* active state */

    /* BOTTOM BARS ================================= */
    .bar {
        position: relative;
        display: block;
        width: $width;
    }

    .bar:before, .bar:after {
        content: '';
        height: 2px;
        width: 0;
        bottom: 1px;
        position: absolute;
        background: $accent-1;
        transition: $transition-time ease all;
    }

    .bar:before {
        left: 50%;
    }

    .bar:after {
        right: 50%;
    }

    /* active state */
    input:focus ~ .bar:before, input:focus ~ .bar:after {
        width: 50%;
    }


</style>
